import { connect } from 'react-redux';

import { selectors as userSelectors } from 'dux/user';
import InstancesPageRedirect from './InstancesPageRedirect';

const mapStateToProps = (state) => ({
  userRoles: userSelectors.getIdentityState(state).roles,
});

export default connect(mapStateToProps, null)(InstancesPageRedirect);
